// src/utils/constants.js
// Central place for all app-wide constants.
// ⚠️ Update WHATSAPP_NUMBER before going live.

export const BRAND = {
  name: "Sunaharco",
  tagline: "Crafted for Every Choice",
  taglineAlt: "Crafted for Sustainable Products",
  email: {
    general: "info@sunaharco.com",
    sales: "sales@sunaharco.com",
    technical: "technical@sunaharco.com",
    marketing: "marketing@sunaharco.com",
    operations: "operations@sunaharco.com",
    finance: "finance@sunaharco.com",
  },
  // ⚠️ Replace with actual WhatsApp number (country code + number, no spaces)
  whatsappNumber: "918679085556",
  // Social links (add when available)
  social: {
    instagram: "",
    facebook: "",
    linkedin: "",
  },
};

export const SEO = {
  defaultTitle: "Sunaharco – Crafted for Every Choice",
  defaultDescription:
    "Premium organic vermicompost and agricultural solutions. Urvaraa Vermicompost for farms, home gardening, and nurseries. 100% organic, chemical-free.",
  keywords: [
    "Sustainability",
    "Agility",
    "Innovation",
    "Environment",
    "Technology",
    "Customized solutions",
    "Problem solving",
    "Better living",
    "Quality & trust",
  ],
};

export const NICHES = {
  PREMIUM_MUGS: "premium-mugs",
  AGRICULTURE: "agriculture",
  ENGINEERING_SERVICES: "engineering-services",
};

export const FIRESTORE_COLLECTIONS = {
  PRODUCTS: "products",
  NICHES: "niches",
  ENQUIRIES: "enquiries",
  CONFIG: "config",
};

export const PRODUCT_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  COMING_SOON: "comingSoon",
};

// Nav links — used by Navbar and Footer
export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Directors", to: "/leadership" },
  { label: "Contact", to: "/contact" },
];
